const settings = {}

export default settings